// Sum the `percentage` of each allocation row. Empty / non-numeric values
// count as 0, and the result is rounded to 2 decimals to avoid float noise.
export function sumPercentages(rows) {
  const sum = (rows || []).reduce(
    (acc, row) => acc + (Number.parseFloat(row?.percentage) || 0),
    0
  );
  return Math.round(sum * 100) / 100;
}
